import {useEventBus} from "./use-event-bus";

export class Header {
    private readonly idToggle = '#hd-nav-toggle';
    private readonly idOpen = '#hd-nav-open';
    private readonly idClose = '#hd-nav-close';
    private readonly idMenu = '#hd-nav-menu';
    private readonly classSearch = '.hd-header-search';
    private readonly scrolledClass = 'scrolled';
    private readonly openClass = 'open';
    private readonly mobileBreakpoint = 991;
    private readonly closeOnResize = false;

    private bodyEl: HTMLElement;
    private el: HTMLElement;
    private menuEl: HTMLElement | null;
    private toggleEl: HTMLElement | null;
    private openEl: HTMLElement | null;
    private closeEl: HTMLElement | null;
    private searchEl: HTMLElement | null;

    private isOpen = false;

    private scrollFn;
    private toggleFn;
    private openFn;
    private closeFn;
    private resizeFn;
    private rafCb;

    private closeClearTimeoutId;
    private openTimeoutId;

    constructor(el) {
        this.bodyEl = document.body;
        this.el = el;
        this.menuEl = this.el.querySelector(this.idMenu);
        this.toggleEl = this.el.querySelector(this.idToggle);
        this.openEl = this.el.querySelector(this.idOpen);
        this.closeEl = this.el.querySelector(this.idClose);
        this.searchEl = el.querySelector(this.classSearch);
    }

    onInit() {
        this.scrollFn = this.onScroll.bind(this);
        window.addEventListener('scroll', this.scrollFn);
        if (this.closeOnResize) {
            this.resizeFn = this.onResize.bind(this);
            window.addEventListener('resize', this.resizeFn);
        }
        if (this.toggleEl) {
            this.toggleFn = this.onToggle.bind(this);
            this.toggleEl.addEventListener('click', this.toggleFn);
        }
        if (this.openEl) {
            this.openFn = this.open.bind(this);
            this.openEl.addEventListener('click', this.openFn);
        }
        if (this.closeEl) {
            this.closeFn = this.close.bind(this);
            this.closeEl.addEventListener('click', this.closeFn);
        }
        this.onScroll();
        this.bindSearchValueClass();
        // this.calculateMainPadding();
    }

    onDestroy() {
        if (this.scrollFn) {
            window.removeEventListener('scroll', this.scrollFn);
        }
        if (this.resizeFn) {
            window.removeEventListener('resize', this.resizeFn);
        }
        if (this.toggleEl && this.toggleFn) {
            this.toggleEl.removeEventListener('click', this.toggleFn);
        }
        if (this.openEl && this.openFn) {
            this.openEl.removeEventListener('click', this.openFn);
        }
        if (this.closeEl && this.closeFn) {
            this.closeEl.removeEventListener('click', this.closeFn);
        }
    }

    // private calculateMainPadding() {
    //     // TODO: use div with class
    //     // TODO: learn how to get white header
    //     const mainEl: HTMLElement | null = this.bodyEl.querySelector('.main');
    //     if (!mainEl) {
    //         return;
    //     }
    //     const children: Element[] = Array.from(mainEl.children).filter(child => child.nodeName !== 'SCRIPT');
    //     if (!children || children.length === 0) {
    //         const height = '100px';
    //         mainEl.style.paddingTop = height;
    //     }
    //     const firstChild = children[0];
    //     const firstChildIsImage = firstChild.classList.contains('hd-hero-image') || firstChild.classList.contains('hd-slider');
    //     if (firstChildIsImage) {
    //         // height of purple nav
    //         if (window.innerWidth > 767) {
    //             const height = '50px';
    //             mainEl.style.paddingTop = height;
    //         }
    //     } else {
    //         const height = '200px';
    //         mainEl.style.paddingTop = height;
    //     }
    // }


    private closeSearch() {
        if (!this.searchEl) {
            return;
        }
        // this.isOpenSearch = false;
        // this.searchEl.classList.remove(this.searchOpenClass);
    }

    private openSearch() {
        this.clearSearch();
    }

    private clearSearch() {
        if (!this.searchEl) {
            return;
        }
        const input = this.searchEl.querySelector('input');
        if (input) {
            input.value = '';
        }
    }

    private bindSearchValueClass() {
        if (!this.searchEl) {
            return;
        }
        const form = this.searchEl.querySelector('form');
        const input = this.searchEl.querySelector('input');
        if (input) {
            input.addEventListener('input', (event) => {
                if (!form || !event || !event.target) {
                    return;
                }
                if ((<HTMLInputElement>event.target).value.trim().length > 0) {
                    form.classList.add('has-value');
                } else {
                    form.classList.remove('has-value');
                }
            });
        }
    }

    private onToggle() {
        this.isOpen ? this.close() : this.open();
    }

    private onScroll() {
        const scrollPosition = window.scrollY;
        if (scrollPosition > 0) {
            this.el.classList.add(this.scrolledClass);
        } else {
            this.el.classList.remove(this.scrolledClass);
        }
    }

    private onResize() {
        const width = window.innerWidth;
        if (this.isOpen && width >= this.mobileBreakpoint) {
            this.close();
        }
    }

    private close() {
        clearTimeout(this.closeClearTimeoutId);
        clearTimeout(this.openTimeoutId);
        this.bodyEl.style.overflow = 'auto';
        this.isOpen = false;
        this.el.classList.remove(this.openClass);
        if (this.menuEl) {
            this.menuEl.style.display = 'block';
        }
        this.closeClearTimeoutId = setTimeout(() => {
            if (this.menuEl) {
                this.menuEl.style.display = '';
            }
        }, 350);
    }

    private open() {
        clearTimeout(this.closeClearTimeoutId);
        clearTimeout(this.openTimeoutId);
        this.clearSearch();
        this.bodyEl.style.overflow = 'hidden';
        this.isOpen = true;
        if (this.menuEl) {
            this.menuEl.style.display = 'block';
        }
        this.openTimeoutId = setTimeout(() => {
            this.el.classList.add(this.openClass);
        }, 10);
    }

}

export function useHeader() {
    useEventBus('hd-header-main', Header);
}